import React from "react";
import styled from "@emotion/styled";
import {
  Divider as MuiDivider,
  Typography,
  IconButton as MuiIconButton,
} from "@mui/material";
import {
  SaveAs as SaveIcon,
  RestartAlt as ResetIcon,
} from "@mui/icons-material";
import { spacing } from "@mui/system";

import Mindmap from "../../components/pages/mindmap/Mindmap";
import { updateMindmapState } from "../../firebase/utils";
import { SnackbarFns } from "../../utils/fnsRedux";

const Divider = styled(MuiDivider)(spacing);

const MainContainer = styled.div`
  width: 100%;
  height: calc(100% - 50px);
`;

const TopSection = styled.div`
  display: flex;
  justify-content: space-between;
`;

const UtilSection = styled.div`
  display: flex;
`;

const IconButton = styled(MuiIconButton)`
  height: 40px;
`;

function MindmapPage() {
  const handleSnackbar = SnackbarFns();
  const [resetLayout, setResetLayout] = React.useState<boolean>(false);

  function saveState() {
    const diagramElement: any = document.getElementById("diagram");
    const diagram: any = diagramElement.ej2_instances[0];
    const saveData: string = diagram.saveDiagram();
    updateMindmapState(saveData);
    handleSnackbar("success", "Mindmap saved", true);
  }

  return (
    <MainContainer>
      <TopSection>
        <Typography variant="h3" gutterBottom display="inline">
          Mindmap
        </Typography>
        <UtilSection>
          <IconButton onClick={() => setResetLayout(true)}>
            <ResetIcon sx={{ fontSize: "24px" }} />
          </IconButton>
          <IconButton onClick={() => saveState()}>
            <SaveIcon sx={{ fontSize: "24px" }} />
          </IconButton>
        </UtilSection>
      </TopSection>
      <Divider my={6} />
      <Mindmap reset={resetLayout} setReset={setResetLayout} />
    </MainContainer>
  );
}

export default MindmapPage;
